import { Dimensions } from "../dimensions/primitives";

export const Radius = {
  container: {
    default: Dimensions[1],
  },
  component: {
    default: Dimensions[1],
    round: "999px",
    checkbox: "2px",
    tag: "2px",
    buttonLarge: Dimensions[1],
    filter: "999px",
    dropdown: Dimensions[1],
    modalDesktopDefault: Dimensions[1],
    modalMobileDefault: Dimensions[3],
    modalMobileLarge: Dimensions[3],
    promptModal: Dimensions[1],
    toast: Dimensions[1],
  },
} as const;

export default {
  Radius,
} as const;
